// extracted by mini-css-extract-plugin
export default {"collapsibleSection":"collapsibleSection__collapsibleSection__Ls3Oc","infoLabel":"collapsibleSection__infoLabel__lO98a"};